import { useEffect } from 'react';

export const useDynamicManifest = (options: {
    title: string;
    iconUrl: string;
    startUrl: string;
    themeColor?: string;
    isActive: boolean;
}) => {
    useEffect(() => {
        if (!options.isActive) return;

        // 1. Update Title
        const originalTitle = document.title;
        document.title = options.title;

        // 2. Update Apple Touch Icon
        let appleIcon = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement;
        const originalAppleIconHref = appleIcon ? appleIcon.href : '/assets/goodieboy.png';
        if (!appleIcon) {
            appleIcon = document.createElement('link');
            appleIcon.rel = 'apple-touch-icon';
            document.head.appendChild(appleIcon);
        }
        appleIcon.href = options.iconUrl;

        // 3. Update or Create Manifest
        let manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
        let originalManifestHref = manifestLink ? manifestLink.href : null;

        const manifest = {
            name: options.title,
            short_name: options.title,
            start_url: options.startUrl,
            display: "standalone",
            theme_color: options.themeColor || "#0d1117",
            background_color: "#0d1117",
            icons: [
                {
                    src: options.iconUrl,
                    sizes: "192x192 512x512",
                    type: "image/png",
                    purpose: "any maskable"
                }
            ]
        };

        const stringManifest = JSON.stringify(manifest);
        const blob = new Blob([stringManifest], { type: 'application/json' });
        const manifestURL = URL.createObjectURL(blob);

        if (!manifestLink) {
            manifestLink = document.createElement('link');
            manifestLink.rel = 'manifest';
            document.head.appendChild(manifestLink);
        }
        manifestLink.href = manifestURL;

        return () => {
            // Cleanup and revert
            document.title = originalTitle;
            if (appleIcon) appleIcon.href = originalAppleIconHref;
            if (manifestLink) {
                if (originalManifestHref) {
                    manifestLink.href = originalManifestHref;
                } else {
                    manifestLink.remove();
                }
            }
            URL.revokeObjectURL(manifestURL);
        };
    }, [options.title, options.iconUrl, options.startUrl, options.themeColor, options.isActive]);
};
